var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_vm._m(0),(_vm.resultSearchParams)?_c('Result',{attrs:{"params":_vm.resultSearchParams}}):_c('Form')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-banner"},[_c('img',{attrs:{"src":"//s1.hdslb.com/bfs/static/jinkela/passport/static/img/rl_top.35edfde.png"}})])
}]

export { render, staticRenderFns }